<template>
    <v-dialog
        v-model="showModal"
        persistent
        max-width="700"
        scrollable
    >
        <v-card>

            <div class="d-flex align-center py-2">
                <v-card-title class="headline mr-auto">
                    Datos de contacto
                </v-card-title>
                <v-btn class="mx-2" color="primary" @click="newFiscalContact()" v-if="content === 'list'">
                    Nuevo
                </v-btn>
                <v-btn class="mr-4" fab small text @click="closeModal()">
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
            </div>


            <v-divider class="mx-4"></v-divider>

            <v-card-text v-if="content === 'list'">
                <v-list v-if="fiscalContactStore.fiscalContacts != null">
                    <v-radio-group v-model="listSelection">
                        <template v-for="(fiscalContact, index) in fiscalContactStore.fiscalContacts" >
                            <v-list-item :key="fiscalContact.id" >
                                <v-list-item-content class="overflow-visible">
                                    <v-radio :value="index">
                                        <template v-slot:label >
                                            <v-list-item-title class="text-h6 overflow-visible">
                                                {{fiscalContact.nombre_contacto}}
                                            </v-list-item-title>
                                            <v-btn class="mr-3" fab x-small color="primary" @click="editFiscalContact(fiscalContact)">
                                                <v-icon>fas fa-edit</v-icon>
                                            </v-btn>
                                            <v-btn fab x-small color="error" @click="removeFiscalContact(fiscalContact.id)">
                                                <v-icon>fas fa-trash</v-icon>
                                            </v-btn>
                                        </template>

                                    </v-radio>
                                  <v-list-item-subtitle class="mb-2 font-weight-bold">CURP: {{fiscalContact.curp}} | RFC: {{fiscalContact.rfc}}</v-list-item-subtitle>
                                    <v-list-item-subtitle class="mb-2 font-weight-bold">Dirección:</v-list-item-subtitle>
                                    <v-list-item-subtitle class="mb-2">
                                        {{fiscalContact.direccion_completa}}
                                    </v-list-item-subtitle>

                                </v-list-item-content>

                            </v-list-item>
                            <v-divider :key="'d'+fiscalContact.id"></v-divider>
                        </template>
                    </v-radio-group>
                    <v-card-subtitle v-if="fiscalContactStore.fiscalContacts.length === 0">
                        No hay "Datos de Contacto" registrados, para agregar uno da clic en el botón "NUEVO"
                    </v-card-subtitle>
                </v-list>
                <v-row v-else>
                    <v-col class="d-flex justify-center py-14">
                        <v-progress-circular
                            :size="50"
                            color="primary"
                            indeterminate
                            class="justify-center"
                        ></v-progress-circular>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text v-if="content === 'form'">
                <v-form v-model="isEditFormValid" ref="fiscalContactForm">
                    <FiscalContactFormEdit
                        :fiscal-contact="fiscalContact"
                        :form-validator="formValidator"
                        :states = "fiscalContactStore.states"
                        :municipalities = "fiscalContactStore.municipalities"
                        :neighborhoods="fiscalContactStore.neighborhoods"
                        :get-municipalities-catalog="getMunicipalitiesCatalog"
                        :get-neighborhoods-catalog="getNeighborhoodsCatalog"
                        :use-procedure-contact="sendProcedureContactToForm"
                    />
                </v-form>
            </v-card-text>

            <v-card-actions class="fixed" v-if="content === 'list'">
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    @click="selectFiscalContactFromList()"
                    class="mr-4"
                    :disabled="listSelection === -1"
                >
                    Guardar
                </v-btn>
            </v-card-actions>

            <v-card-actions class="fixed" v-if="content === 'form'">
                <v-spacer></v-spacer>
                <v-btn
                    color="normal"
                    text
                    @click="cancelCreateFiscalContact()"
                    class="mr-4"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    color="primary"
                    @click="createOrUpdateFiscalContact()"
                    class="mr-4"
                >
                    Guardar
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import fiscalContactFormValidator from "../../../form/fiscal_contact.form.validator";
import FiscalContactFormEdit from "./FiscalContactFormEdit"
import {addressCatalogRequest, createFiscalContactRequest, removeFiscalContactRequest} from "../../../api/models";

export default {
    name: "FiscalContact",
    props: ['showModal', 'selectedFiscalContact', 'closeModal', 'procedureContactDefault'],

    components: {FiscalContactFormEdit},

    computed: {
        ...mapState({cartStore: state => state.cart, fiscalContactStore: state => state.fiscalContact}),
        ...mapGetters('cart', ['']),
        ...mapGetters('fiscalContact', ['']),
    },

    data(){
        return {
            isEditFormValid: false,

            listSelection: -1,
            content: 'list',
            formValidator: fiscalContactFormValidator,
            fiscalContact: {
                id: 0,
                estado_id: '',
                municipio_id: '',
                colonia: '',
            }
        }
    },

    mounted() {
        this.getFiscalContactList()
    },

    methods: {
        ...mapActions('fiscalContact', ['getAddressCatalog', 'getFiscalContacts', 'createFiscalContact', 'deleteFiscalContact', 'updateFiscalContact']),

        getFiscalContactList(){
            this.getFiscalContacts()
        },

        /****** ACTIONS FOR CREATE/EDIT FORM  ******/
        newFiscalContact(){
            this.content = 'form'

            this.getSatesCatalog()
            this.getMunicipalitiesCatalog(this.fiscalContact.estado_id)
        },

        createOrUpdateFiscalContact(){
            this.$refs.fiscalContactForm.validate();

            if (this.isEditFormValid){
                let request = createFiscalContactRequest()
                request.datos_solicitante = this.fiscalContact

                if (this.fiscalContact.id > 0){
                    this.updateFiscalContact(request)
                }else {
                    this.createFiscalContact(request)
                }

                this.resetForm()
            }
        },

        cancelCreateFiscalContact(){
            this.resetForm()
        },

        removeFiscalContact(id){
            if (confirm("¿Esta seguro de eliminar el dato fiscal?")){
                let request = removeFiscalContactRequest()
                request.id = id
                this.deleteFiscalContact(request)
            }
        },

        editFiscalContact(fiscalContact){
            // console.log(JSON.stringify(fiscalContact))
            this.fiscalContact = Object.assign({}, fiscalContact)
            delete this.fiscalContact.nombre_contacto
            delete this.fiscalContact.direccion_completa
            this.content = 'form'


            this.getSatesCatalog()
            this.getMunicipalitiesCatalog(this.fiscalContact.estado_id)

            if (this.fiscalContact.municipio_id > 0){
                this.getNeighborhoodsCatalog(this.fiscalContact.estado_id, this.fiscalContact.municipio_id)
            }
        },

        resetForm(){
            this.content = 'list'
            this.fiscalContact= {
                id: 0,
                estado_id: '',
                municipio_id: '',
                colonia: ''
            }
        },

        getSatesCatalog(){
            let request = addressCatalogRequest()
            request.catalog = 'states'

            this.getAddressCatalog(request)
        },

        getMunicipalitiesCatalog(stateId){
            let request = addressCatalogRequest()
            request.catalog = 'municipalities'
            request.state_id = stateId

            this.getAddressCatalog(request)
        },

        getNeighborhoodsCatalog(stateId, municipalityId){
            let request = addressCatalogRequest()
            request.catalog = 'neighborhoods'
            request.state_id = stateId
            request.municipality_id = municipalityId

            this.getAddressCatalog(request)
        },

        selectFiscalContactFromList(){
            if (this.listSelection > -1){
                this.selectedFiscalContact(this.fiscalContactStore.fiscalContacts[this.listSelection])
            }else{
                alert('Selecciona un contacto en el listado.')
            }
        },
        /****** FINISH FORM ACTIONS ****/

        sendProcedureContactToForm(){
            if (this.procedureContactDefault.nombre || this.procedureContactDefault.apellido_pat || this.procedureContactDefault.apellido_pat){
                this.fiscalContact.nombre = this.procedureContactDefault.nombre
                this.fiscalContact.apellido_pat = this.procedureContactDefault.apellido_pat
                this.fiscalContact.apellido_mat = this.procedureContactDefault.apellido_mat
            }else{
                alert("No se econtraron datos previos del solicitante.")
            }
        }
    }
}
</script>

<style scoped>

</style>